import dayjs from 'dayjs';
import 'dayjs/locale/fr';

dayjs.locale('fr');

export const fmtTime = (iso: string) => dayjs(iso).format('HH:mm');
export const fmtDayLong = (iso: string) => dayjs(iso).format('dddd D MMMM YYYY');
export const fmtDayShort = (iso: string) => dayjs(iso).format('dddd D MMMM');
export const fmtDate = (iso: string) => dayjs(iso).format('DD/MM/YYYY');

// Dates en toutes lettres de « Mes documents » et de la rétractation (vente à distance, T17).
const WEEKDAYS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
const MONTHS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

/**
 * Jour AAAA-MM-JJ en toutes lettres : « jeudi 5 novembre », « dimanche 1er novembre » ; l'année est ajoutée si elle
 * diffère de celle de `today`. Le jour est lu tel quel, sans conversion de fuseau (jours rendus par le serveur) ;
 * '' s'il est illisible.
 */
export function fmtDayFull(day: string, today = dayjs().format('YYYY-MM-DD')): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(day);
  if (!m) return '';
  const [year, month, date] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const text = `${WEEKDAYS[new Date(Date.UTC(year, month - 1, date)).getUTCDay()]} ${date === 1 ? '1er' : date} ${MONTHS[month - 1]}`;
  return m[1] === today.slice(0, 4) ? text : `${text} ${year}`;
}

/** Heure d'un instant dans le fuseau du navigateur : « 14 h », « 14 h 05 », « 9 h ». */
export function fmtClock(iso: string): string {
  const at = dayjs(iso);
  return at.minute() ? `${at.hour()} h ${String(at.minute()).padStart(2, '0')}` : `${at.hour()} h`;
}

/** Jour AAAA-MM-JJ d'un instant, dans le fuseau du navigateur. */
export const dayOf = (iso: string) => dayjs(iso).format('YYYY-MM-DD');

export const isSameDay = (a: string, b: string) =>
  dayjs(a).isSame(dayjs(b), 'day');
export const isToday = (iso: string) => dayjs(iso).isSame(dayjs(), 'day');

export const initials = (first: string, last: string) =>
  `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();

export default dayjs;
